module.exports = __webpack_public_path__ + "static/img/Taylor-Walker.e320950.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Taylor-Walker.jpg
// module id = amiv
// module chunks = 0